module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "definitions"
  }, [(_vm.definitionTag) ? _c('div', [(!_vm.definition) ? _c('loading') : _vm._e(), (_vm.definition) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.definition.title))]), _c('div', {
    staticClass: "definitions-content",
    domProps: {
      "innerHTML": _vm._s(_vm.definition.content)
    }
  })]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ddbfd15","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Glossary.vue
// module id = AyOA
// module chunks = 0 1